import MainLiveBulkLoad from '../components/Live/MainLiveBulkLoad';
import * as React from 'react';
import Header from "../components/Header";
import Sidebar from "../components/sidebar";

export interface ILiveBulkLoadScreenProps {
}

export default function LiveBulkLoadScreen (props: ILiveBulkLoadScreenProps) {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainLiveBulkLoad />
      </main>
    </>
  );
}
